// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__35qLK","list":"PatternAutocomplete_list__26GFi"};